import { PagedRequestDto } from '../paged-request.model';
import { Location } from '../location.model';
import { FacilityClassification, FacilityType } from '../../enums';
import { ScopeOfPracticeEnum } from '@umss/shared/utils';

export interface FacilityDto {
  /**
   * format: int32
   */
  facilityTypeId?: number;

  facilityTypeName?: string;

  facilityTypeHasSubtypes: boolean;

  classification: FacilityClassification;

  classificationDisplay: string;

  status: FacilityStatus;

  statusDisplay: string;
  /**
   * format: uuid
   */
  corporationId?: string;

  corporationName?: string;

  billingManagedByCorporate: boolean;

  location: Location;

  contactPhone?: string;

  contactEmail?: string;

  websiteUrl?: string;

  onboardingCompleted: boolean;
  /**
   * format: date
   */
  contractSignedDate?: string;

  timeZone?: string;

  supportedScopes: ScopeOfPracticeEnum[];

  contacts: FacilityContactDto[];
  /**
   * format: double
   */
  distanceMiles?: number;

  isFavorite: boolean;
  /**
   * minLength: 0
   * maxLength: 255
   */
  name: string;
  /**
   * minLength: 0
   * maxLength: 1000
   */
  description?: string;

  isActive: boolean;
  /**
   * format: uuid
   */
  id: string;
  /**
   * format: date-time
   */
  createdAt: string;
  /**
   * format: date-time
   */
  updatedAt: string;
}

export enum FacilityStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Pending = 'Pending',
  Suspended = 'Suspended'
}

export interface FacilityContactDto {
  id: number;
  contactType: string;
  firstName: string;
  lastName: string;
  fullName: string;
  title?: string | null;
  email?: string | null;
  phone?: string | null;
  isPrimary: boolean;
}

export interface FacilitySearchDto extends PagedRequestDto {
  // Filtros específicos de Facility
  classification?: FacilityClassification | null;
  isActive?: boolean | null; // Filter by active status. Defaults to true (only active facilities). Set to false for inactive only, or null for all facilities
  facilityTypeId?: number | null;
  stateCode?: string | null;
  latitude?: number | null; // decimal
  longitude?: number | null; // decimal
  radiusMiles?: number | null; // double
  corporateId?: string | null;
  status?: FacilityStatus | null;
}

export interface CreateFacilityDto extends CreateNamedEntityDto {
  isActive?: boolean; // Default true
  facilityTypeId: FacilityType;
  classification?: FacilityClassification; // Required
  location?: CreateLocationDto | null;
  contactPhone?: string | null; // Phone validation, max 20 characters
  contactEmail?: string | null; // Email validation, max 255 characters
  websiteUrl?: string | null; // URL validation
  contractSignedDate?: string | null; // DateOnly as ISO string (YYYY-MM-DD)
  supportedScopes?: ScopeOfPracticeEnum[]; // Default empty array
}

export interface CreateNamedEntityDto {
  name: string; // Required, max 255 characters
  description?: string | null; // Optional, max 1000 characters
}

export interface CreateLocationDto {
  addressLine1: string; // Required, max 255 characters
  addressLine2?: string | null; // Optional, max 255 characters
  city: string; // Required, max 100 characters
  stateCode: string; // Required, max 2 characters
  zipCode: string; // Required, max 10 characters
}

export interface UpdateFacilityDto extends CreateNamedEntityDto {
  facilityTypeId?: FacilityType; // Required
  classification: FacilityClassification;
  status?: FacilityStatus; // Required
  location?: CreateLocationDto | null;
  contactPhone?: string | null; // Phone validation, max 20 characters
  contactEmail?: string | null; // Email validation, max 255 characters
  websiteUrl?: string | null; // URL validation
  isActive?: boolean; // Default true
  supportedScopes?: ScopeOfPracticeEnum[]; // Default empty array
}
